'use client';
import React, { useState, useEffect } from 'react';
import './dailStyle.css';

const SpeedDial = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Handle scroll event
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = (scrollTop / docHeight) * 100;

    setScrollProgress(scrolled);

    // Show button only after scrolling 100px
    if (scrollTop > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    const scrollStep = -window.scrollY / (3000 / 16); // Adjust 500 for desired speed
    const scrollAnimation = () => {
      if (window.scrollY > 0) {
        window.scrollBy(0, scrollStep);
        requestAnimationFrame(scrollAnimation);
      }
    };
    requestAnimationFrame(scrollAnimation);
  };

  return (
    <div>
      {isVisible && (
        <div className='fixed bottom-5 left-2 z-50 flex flex-col items-center scroll-smooth rounded-full bg-blue-500 bg-opacity-60 active:scale-90 transition-all duration-300 text-secondary'>
          <div
            className='w-9 h-9 rounded-full flex justify-center items-center cursor-pointer relative text-secondary '
            onClick={scrollToTop}
            title='Scroll To The Top !!'
          >
            {/* Scroll Progress */}
            <div
              className='absolute inset-0 rounded-full z-0 '
              style={{
                background: `conic-gradient(#2563eb ${scrollProgress}%, gray ${scrollProgress}% 100%)`,
              }}
            ></div>

            {/* Overlay to create a circular cutout */}
            <div className='absolute inset-2 bg-white border rounded-full z-10'></div>

            {/* SVG Button */}
            <button className='p-1 md:p-2 text-blue-950 z-20 relative'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='w-5 h-5'
              >
                <path d='M19 14l-7-7-7 7'></path>
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpeedDial;
